import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { queryRepair, delRepairRegistration, subRepairRegistration } from '@/api/repairs/repairsApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '报修单号',
      dataIndex: 'number',
      align: 'center',
      resizable: true,
      width: 15
    }, {
      title: '联系电话',
      dataIndex: 'phone',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 12
    }, {
      title: '设备名称',
      dataIndex: 'itemName',
      ellipsis: true,
      align: 'center',
      resizable: true,
      width: 15
    }, {
      title: '设备型号',
      dataIndex: 'itemModel',
      ellipsis: true,
      align: 'center',
      width: 15
    }, {
      title: '设备位置',
      dataIndex: 'location',
      ellipsis: true,
      align: 'center',
      width: 15
    }, {
      title: '使用部门',
      dataIndex: "drafterTemp",
      scopedSlots: {
        customRender: 'drafterTemp'
      },
      ellipsis: true,
      align: 'center',
      width: 20
    }, {
      title: '故障时间',
      dataIndex: 'reDate',
      ellipsis: true,
      align: 'center',
      width: 20
    }, {
      title: '故障描述',
      dataIndex: 'description',
      align: 'center',
      width: 20
    }, {
      title: '维修状态',
      dataIndex: 'repairsStatus',
      align: 'center',
      width: 10,
      scopedSlots: {
        customRender: 'repairsStatus'
      }
    }, {
      title: '操作',
      dataIndex: '',
      align: 'center',
      width: 10,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      // pagination: this.$hdk.page(),
      pagination: this.$hdk.page(),
      //分页索引
      expand: false,
      loading: false,
      formState: {
        title: '',
        serialNumber: '',
        type: undefined,
        node: '',
        repairsStatus: undefined,
        time: []
      },
      text: '',
      columns: columns,
      list: []
    };
  },
  methods: {
    /**
     *切换分页时调用
     */
    change: function change(pagination) {
      this.getQueryRepair({
        current: pagination.current,
        pageSize: pagination.pageSize,
        formState: this.formState
      });
    },
    /**
     * 点击评价跳转页面
     */
    evaluationClick: function evaluationClick(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.id,
          mode: 'evaluation',
          backTo: 'repair',
          repairsStatus: row.repairsStatus
        }
      });
      // this.evaluation = true;
    },
    /**
     * 列表提交
     */
    listSubmit: function listSubmit(data) {
      var _this = this;
      subRepairRegistration(data).then(function (res) {
        if (res.data.code == 200) {
          _this.$message.success('提交成功', 10);
          _this.getQueryRepair();
        } else {
          _this.$message.error('提交失败', 10);
        }
      });
    },
    /**
     * 点击删除显示是否删除按钮
     */
    changeClear: function changeClear(e) {
      var _this2 = this;
      this.visibleShowId = e.id;
      var $confirm = this.$confirm,
        $message = this.$message,
        fetch = this.fetch;
      $confirm('确认删除吗?', '提示', {
        type: 'info',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(function () {
        delRepairRegistration(e.id).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
            _this2.getQueryRepair();
          }
        });
      }).catch(function () {});
    },
    /**
     * 点击查看跳转
     */
    viewRigister: function viewRigister(row) {
      this.$router.push({
        path: '/reimburseRepairs/repairs/repairsDetail',
        query: {
          id: row.id,
          mode: 'view',
          backTo: 'repair',
          repairsStatus: row.repairsStatus
        }
      });
    },
    /**
     * 条件筛选
     */
    searchClick: function searchClick() {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getQueryRepair();
    },
    /**
     * 获取报修登记列表
     */
    getQueryRepair: function getQueryRepair(options) {
      var _this3 = this;
      var pagination = this.pagination,
        formState = this.formState,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (this.formState.time.length > 0) {
        this.formState.startTime = this.formState.time[0];
        this.formState.endTime = this.formState.time[1];
      } else {
        this.formState.startTime = null;
        this.formState.endTime = null;
      }
      if (!pager.formState) {
        pager.formState = formState;
      }
      // return;
      queryRepair(pager.current, pager.pageSize, pager.formState).then(function (res) {
        _this3.list = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(formState, pager.formState);
      }).finally(function () {
        _this3.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getQueryRepair();
  }
};